import React, {useEffect, useMemo, useState} from "react";
import LinkIcon from "@mui/icons-material/Link";
import styles from "./SectionTagCopy.module.scss";

async function copyToClipboard(text: string) {
    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "true");
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    textarea.style.top = "0";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
}

type Props = {
    anchorId: string;
    label?: string;
};

function SectionTagCopy({anchorId, label}: Props) {
    const [copied, setCopied] = useState(false);

    const display = useMemo(() => label ?? ``, [anchorId, label]);

    useEffect(() => {
        if (!copied) return;
        const t = window.setTimeout(() => setCopied(false), 1100);
        return () => window.clearTimeout(t);
    }, [copied]);

    return (
        <button
            type="button"
            className={styles.btn}
            aria-label={`Скопировать ссылку ${display}`}
            onClick={async () => {
                const url = `${window.location.origin}${window.location.pathname}#${anchorId}`;
                await copyToClipboard(url);
                setCopied(true);
            }}
        >
            <span className={styles.text}>#{display}</span>
            {copied ? <span className={styles.badge}>Скопировано</span> : null}
            <LinkIcon sx={{fontSize: 18}}/>
        </button>
    );
}

export default SectionTagCopy;
